import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const features = ['Alerts at 30+ PPM — hours before traditional detectors', '4-stage color alert: Green → Yellow → Orange → Red', 'Real-time CO, temperature & humidity monitoring', '2-inch IPS HD color display — readable day and night', 'Plug & play — no tools, no wiring, no dead batteries at 3 AM', '10-year sensor lifespan with daily self-diagnostics', 'CE & FCC certified for US, UK, CA, AU'];
export function SolutionSection() {
  return <section className="w-full bg-bg-alt py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-347">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center" data-id="element-348">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="order-2 lg:order-1" data-id="element-349">
          <img src="https://cdn.magicpatterns.com/uploads/pzJYBRuLjK1CDbdGs7bsB1/AirGuard™.png" alt="AirGuard™ CO Detector — Widely Used in Kitchen, Bedroom, Hotel, Apartment, RV" className="w-full h-auto rounded-xl shadow-card" data-id="element-350" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="order-1 lg:order-2 flex flex-col" data-id="element-351">
          <span className="text-accent-orange font-medium text-[12px] tracking-wide uppercase mb-2 block" data-id="element-352">
            INTRODUCING AIRGUARD PRO
          </span>
          <h2 className="text-[28px] md:text-[32px] font-bold text-text-primary mb-3 leading-[1.2]" data-id="element-353">
            Stop Guessing. See Exactly What Your Family Is Breathing.
          </h2>
          <div className="text-[16px] text-text-secondary leading-[1.45] mb-4 space-y-2.5" data-id="element-354">
            <p data-id="element-355">
              AirGuard Pro is the first plug-in CO monitor that shows you the
              exact PPM level in real time — on a crisp 2-inch IPS color display
              you can read from across the room. No more invisible threats. No
              more trusting a green light that expired years ago.
            </p>
            <p data-id="element-356">
              It doesn't just detect. It communicates — with a 4-stage color
              alert system your eyes understand before your brain does.
            </p>
          </div>
          <div className="space-y-1.5 mb-5" data-id="element-357">
            {features.map((f, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-358">
                <CheckCircle2 className="w-5 h-5 text-accent-green flex-shrink-0 mt-0.5" data-id="element-359" />
                <span className="text-text-primary text-[15px]" data-id="element-360">{f}</span>
              </div>)}
          </div>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full sm:w-auto bg-accent-orange hover:bg-[#FF6E38] text-white font-bold text-[16px] uppercase py-[18px] px-10 rounded-lg transition-colors duration-300 self-start" data-id="element-361">
            PROTECT MY FAMILY NOW
          </button>
        </motion.div>
      </div>
    </section>;
}